import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'


class Seo extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 150px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 50px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 200px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 100px;
            @media (min-width:768px) and (max-width:1500px) {
                margin-top: 100px;              
            }
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
            margin-bottom: 0px;
        `

        const ServiceHeadinga = styled.a`
            font-family: Oswald;
            color: #4285f4;
            transition: .5s;
            &:hover {
              color: #1a1a1a;
              text-decoration: none;
            }
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #4285f4;
            margin-bottom: 5px;
        `

        const ServiceLinea = styled.div`
            height: 1px;
            width: 200px;
            background-color: #808080;
            margin: 2px 0 7px 0;
         `

         const ServiceNumber = styled.p`            
            position: absolute;
            font-size: 40px;
            color: #717171;
            font-weight: 900;
            top: -60px;
            opacity: .1;            
            transition: .2s;
         `

         const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .5 !important;
                color: #0274c4;
            }
        `
         
         const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #808080;
            padding-right: 25px;            
        `

         const ServicePrecio = styled.p`
            font-size: 30px;
            font-weight: 300;
            color: #000000;
            padding-right: 25px;            
        `        

        const Submit = styled.a`
            background-color: #fff !important;
            color: #4285f4 !important;
            border: solid 1px #4285f4;
            cursor: pointer !important;
            border-radius: 3px;
            font-size: 14px;
            line-height: 1;
            margin: 0;
            padding: 17px 26px;
            position: relative;
            letter-spacing: 0.02em;
            font-family: "Open Sans Semibold";
            box-shadow: 0 2px 8px 0 rgba(62, 62, 79, .23);
	        -webkit-transition: all 300ms linear 0ms;
	        -moz-transition: all 300ms linear 0ms;
	        -ms-transition: all 300ms linear 0ms;
            transition: all 300ms linear 0ms;
            display: inline-block;
            font-weight: 400;            
            text-transform: uppercase;          
            &:hover {              
                transform: translateX(-20%);
                text-decoration: none;
                background-color: #c1eb18 !important;
	            color: #000 !important;
	            border: none;
                box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .30);
	            -webkit-transform: translateY(-5px);
	            transform: translateY(-5px);              
            }            
        `

        const Color = styled.span`            
            font-weight: bold;
            color: #6c6c6c;            
        `        
        const ColorOrg = styled.span`            
            font-weight: bold;
            color: #4285f4;            
        `
        const Heading3 = styled.h3`
            font-size: 30px;
            font-family: Poppins;
            color: #4285f4;
            line-height: 40px;
            margin-top: 50px;
        `
        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #4a4949;
            padding-bottom: 30px;
        `
        const Heading2 = styled.h2`
            font-size: 40px;
            font-family: Poppins;
            line-height: 50px;
            color: #000;
            font-weight: 700;
            margin-top: 50px;
            text-align: center;
            text-transform: uppercase;
            background: -webkit-linear-gradient(left, #3381f3, #7133ff);
            background: -o-linear-gradient(right, #3381f3, #7133ff);
            background: -moz-linear-gradient(right, #3381f3, #7133ff);
            background: linear-gradient(to right, #3381f3, #7133ff); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 40px;
            }           
        `

        const { data } = this.props;
        // Agregar verificación para asegurarse de que los datos están disponibles
        if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
            return <div>Loading...</div>;
        }
        
        const prices = data.allPricesJson.nodes[0].items;

        console.log(prices)

        return(
            <Section>
                <Container>
                    <Heading2>
                        Da el paso hacia una estrategia SEO sin ataduras
                    </Heading2>
                    <Heading3>Backlinks contextuales DoFollow</Heading3>
                    <Text>En un mundo cada vez más digitalizado, es crucial que tu negocio destaque en línea.
                        Nuestros planes de Backlinks contextuales DoFollow económicos, te ofrecen la oportunidad de mejorar tu visibilidad y
                        llegar a más clientes potenciales sin romper tu presupuesto.
                    </Text>
                    <ServiceRow>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    DA60A90
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=267">
                                        2.000 Backlinks
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    <ColorOrg>1</ColorOrg> url
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <ColorOrg>5</ColorOrg> palabras clave
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Backlinks DoFollow <Color>white hat de alta calidad</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Entrega en <Color>10</Color> días
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Informe mensual
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === '900').price}
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=267">
                                    <span>
                                        Contratar
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    DA60A90
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=268">
                                        6.500 Backlinks
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    <ColorOrg>2</ColorOrg> urls
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <ColorOrg>10</ColorOrg> palabras clave
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Backlinks DoFollow <Color>white hat de alta calidad</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Entrega en <Color>20</Color> días
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Informe mensual
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === '2500').price}
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=268">
                                    <span>
                                        Contratar
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                        <Col md={4}>

                            <ServiceElement>
                                <ServiceNumber>
                                    DA60A90
                                </ServiceNumber>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=269">
                                        12.000 Backlinks
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    <ColorOrg>3</ColorOrg> urls
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <ColorOrg>15</ColorOrg> palabras clave
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Backlinks DoFollow <Color>white hat de alta calidad</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Entrega en <Color>30</Color> días
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Informe mensual
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === '5000').price}
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=269">
                                    <span>
                                        Contratar
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                    </ServiceRow>
                </Container>
            </Section>
        )
    }

}

export const query = graphql`
  query {
    allPricesJson(filter: { page: { eq: "SEO" }, section: { eq: "planes" } }) {
      nodes {
        items {
          name
          price
        }
      }
    }
  }
`

const Ssl = (props) => (
    <StaticQuery
      query={query}
      render={(data) => (
        <Seo
          data={data}
        />
      )}
    />
  )
  export default Ssl;